module.exports = __webpack_public_path__ + "img/app1.970d488d.png";